export enum LoyaltyNotificationStatus {
    New = 0,
    Checked = 1
}